export const statuses = {
  draft: 'Rascunho',
  sent: 'Enviado',
  answered: 'Respondido',
  canceled: 'Cancelado',
};

export function getName(value) {
  return statuses[value] || value;
}

export function getRoundName(round) {
  const value = Number(round) || 1;
  return `${value}ª instância`;
}
